module.exports = __webpack_public_path__ + "img/i_android.86408804.svg";